import styled from 'styled-components';
import Icon from 'js/components/common/Icon';
import { greenColor } from 'js/config/style';

export default styled(Icon)`
  color: ${greenColor};
  margin-right: 0.5rem;
`;
